module.exports = __webpack_public_path__ + "static/media/venues.bc69f0f3.svg";